 

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Block3Columns from "../../components/Block3Columns";
import ConectUs from "../../components/ConectUs";
import OfferPosgrados from "../../components/view/OfferPosgrados";
import { motion } from "framer-motion";
 import logo from "../../img/logo-escuela-de-negocio.png";
import OfferEscuelaNegocios from "../../components/view/OfferEscuelaNegocios";
import {
  CalendarDays,
  GraduationCap,
  Wallet,
  BookOpen,
  Clock3,
  Globe,
  ArrowRight,
  Download,
  DockIcon,
  FlaskConical,
  Handshake,
  Award,
  FileText,
  ClipboardCheck,
  Info,
  HeartPlus,
  BookCheck,
  Sparkles,
  ArrowUpRight,
  MapPin,
  ShieldCheck,
  CheckCircle2,
  ExternalLink,
} from "lucide-react";
import SemanasInternacionales from "./SemanasInternacionalesEscuelaNegocios";
import SegundaTitulacionEscuelaNegocios from "./SegundaTitulacionEscuelaNegocios";
import SemanasInternacionalesEscuelaNegocios from "./SemanasInternacionalesEscuelaNegocios";
import PagosEscuelaNegocios from "./DescuentosEscuelaNegocios";
import DescuentosEscuelaNegocios from "./DescuentosEscuelaNegocios";
  const destinos = [
    {
      universidad: "CENTRUM PUCP",
      ciudad: "Lima, Perú",
      descripcion:
        "Un espacio académico para reflexionar sobre Emprendimiento, Innovación y Futuros 2030, amplía tu visión global, fortalece tus competencias y conecta con tendencias que están transformando el futuro de los negocios y las organizaciones.",
      badge: "Emprendimiento, innovación y futuros 2030",
      bgGradient: "from-blue-50 to-indigo-50",
    },
    {
      universidad: "EDEM",
      ciudad: "Valencia, España",
      descripcion:
        "Aprende marketing digital e inteligencia artificial con casos reales, mientras disfrutas una experiencia cultural única en Valencia.",
      badge: "Marketing Digital & IA",
      bgGradient: "from-amber-50 to-orange-50",
    },
  ];

  const alianzas = [
    {
      tipo: "Título Europeo",
      institucion: "Universidad Politécnica de Valencia",
      siglas: "UPV",
      descripcion:
        "Impulsa tu perfil profesional en el ecosistema educativo europeo con una de las universidades politécnicas de mayor prestigio y reconocimiento en España.",
      enlace: "https://utpl.edu.ec/alianza-upv",
      colorTheme: "from-sky-400 to-indigo-500",
      accentBg: "bg-sky-500/10 text-sky-300 border-sky-400/20",
      beneficios: [
        "Prestigio y calidad del Espacio Europeo de Educación Superior",
        "Conexión con redes de investigación y desarrollo global",
        "Acceso a metodologías europeas de innovación",
      ],
    },
    {
      tipo: "Título Americano",
      institucion: "AGTU - The Global University",
      siglas: "AGTU",
      descripcion:
        "Obtén una ventaja competitiva global con una titulación bajo estándares académicos estadounidenses, diseñada para la flexibilidad y el liderazgo moderno.",
      enlace: "https://agtu.us/es/dual-degree-utpl-agtu/",
      colorTheme: "from-amber-400 to-orange-500",
      accentBg: "bg-amber-500/10 text-amber-300 border-amber-400/20",
      beneficios: [
        "Estándares académicos y enfoque del sistema de EE. UU.",
        "Flexibilidad curricular adaptada a profesionales activos",
        "Enfoque en competencias globales de alta demanda",
      ],
    },
  ];

    const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
    },
  };

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/fc73f51f-b473-4dae-92c2-47ddbbcfb02d" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function EscuelaNegocios() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <>
            <div className="w-60 h-60 flex items-center justify-center">
              <img
                src={logo}
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />{" "}
          </>
        }
      />

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 p-8 md:p-12 shadow-xl border border-[#febe10]/20 max-w-5xl mx-auto my-8"
      >
        {/* Efectos de luz de fondo institucionales */}
        <div className="absolute top-0 right-0 -mt-12 -mr-12 w-72 h-72 bg-[#febe10]/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 -mb-12 -ml-12 w-72 h-72 bg-[#004270]/40 rounded-full blur-3xl pointer-events-none" />

        {/* Inyección de HTML con estilos usando colores de la UTPL */}
        <div
          dangerouslySetInnerHTML={{ __html: data.bloque1 }}
          className="relative z-10 flex flex-col items-start gap-6
      
      /* Estilos para el Periodo (p) - Badge en Amarillo UTPL */
      [&_h4]:text-xs 
      [&_h4]:font-bold 
      [&_h4]:tracking-widest 
      [&_h4]:uppercase 
      [&_h4]:text-[#febe10] 
      [&_h4]:bg-[#febe10]/10 
      [&_h4]:px-3 
      [&_h4]:py-1.5 
      [&_h4]:rounded-full 
      [&_h4]:border 
      [&_h4]:border-[#febe10]/30
      
      /* Estilos para el Título (h2) */
      [&_h2]:text-2xl 
      [&_h2]:md:text-3xl 
      [&_h2]:font-bold 
      [&_h2]:text-white 
      [&_h2]:tracking-tight 
      [&_h2]:leading-tight
      [&_h2]:max-w-3xl
      [&_h2]:m-0
       [&_h2_strong]:text-[#febe10]
      
      /* Estilos para el Botón si viene como enlace (a) */
      [&_a]:inline-flex 
      [&_a]:items-center 
      [&_a]:justify-center 
      [&_a]:px-6 
      [&_a]:py-3 
      [&_a]:mt-2
      [&_a]:text-sm 
      [&_a]:font-bold 
      [&_a]:text-slate-900 
      [&_a]:bg-[#febe10] 
      [&_a]:hover:bg-[#e0a60b] 
      [&_a]:rounded-xl 
      [&_a]:shadow-lg 
    
      [&_a]:transition-all 
      [&_a]:duration-200 
      [&_a]:hover:scale-[1.02]"
        />
      </motion.div>
      <div
        className="max-w-5xl m-auto text-center mt-10"
        dangerouslySetInnerHTML={{
          __html: data.bloque2,
        }}
      />
    </div>
  );

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="pb-16 pt-4">
        <OfferEscuelaNegocios></OfferEscuelaNegocios>
      </div>

        <SemanasInternacionalesEscuelaNegocios/> 

        <SegundaTitulacionEscuelaNegocios/> 

<DescuentosEscuelaNegocios></DescuentosEscuelaNegocios>
     

     

      <div className="padding2">
        <ConectUs
          instagram="https://www.instagram.com/utplescueladenegocios"
          linkedin="https://www.linkedin.com/company/utplescueladenegocios"
          tiktok="https://www.tiktok.com/@utplescueladenegocios"
          facebook="https://www.facebook.com/utplescuelanegocios/"
        ></ConectUs>
      </div>
    </>
  );
}

export default EscuelaNegocios;
